var map = {
	"./clipart/Emojis/Emojis01.png": 5667,
	"./clipart/Emojis/Emojis02.png": 4824,
	"./clipart/Emojis/Emojis03.png": 3889,
	"./clipart/Emojis/Emojis04.png": 798,
	"./clipart/Emojis/Emojis05.png": 4439,
	"./clipart/Emojis/Emojis06.png": 5708,
	"./clipart/Emojis/Emojis07.png": 3221,
	"./clipart/Emojis/Emojis08.png": 2354,
	"./clipart/Emojis/Emojis09.png": 6011,
	"./clipart/Emojis/Emojis10.png": 357,
	"./clipart/Emojis/Emojis11.png": 8732,
	"./clipart/Emojis/Emojis12.png": 9415,
	"./clipart/Emojis/Emojis13.png": 3630,
	"./clipart/Emojis/Emojis14.png": 8193,
	"./clipart/Emojis/Emojis15.png": 9800,
	"./clipart/Emojis/Emojis16.png": 1779,
	"./clipart/Emojis/Emojis17.png": 1946,
	"./clipart/Emojis/Emojis18.png": 1181,
	"./clipart/Emojis/Emojis19.png": 1588,
	"./clipart/Emojis/Emojis20.png": 1792,
	"./clipart/Emotional/Emotional01.png": 7211,
	"./clipart/Emotional/Emotional02.png": 8880,
	"./clipart/Emotional/Emotional03.png": 3705,
	"./clipart/Emotional/Emotional04.png": 3878,
	"./clipart/Emotional/Emotional05.png": 207,
	"./clipart/Emotional/Emotional06.png": 5556,
	"./clipart/Emotional/Emotional07.png": 5501,
	"./clipart/Emotional/Emotional08.png": 5642,
	"./clipart/Emotional/Emotional09.png": 3219,
	"./clipart/Emotional/Emotional10.png": 7997,
	"./clipart/Hats/Hats01.png": 8477,
	"./clipart/Hats/Hats02.png": 1062,
	"./clipart/Hats/Hats03.png": 9807,
	"./clipart/Hats/Hats04.png": 3936,
	"./clipart/Hats/Hats05.png": 9689,
	"./clipart/Hats/Hats06.png": 5682,
	"./clipart/Hats/Hats07.png": 9339,
	"./clipart/Hats/Hats08.png": 9036,
	"./clipart/Hats/Hats09.png": 6549,
	"./clipart/Hats/Hats10.png": 191,
	"./clipart/Love/Love01.png": 8773,
	"./clipart/Love/Love02.png": 942,
	"./clipart/Love/Love03.png": 439,
	"./clipart/Love/Love04.png": 8296,
	"./clipart/Love/Love05.png": 9425,
	"./clipart/Love/Love06.png": 8346,
	"./clipart/Love/Love07.png": 259,
	"./clipart/Love/Love08.png": 7988,
	"./clipart/Love/Love09.png": 9117,
	"./clipart/Love/Love10.png": 8007,
	"./clipart/standard/Standard01.png": 9555,
	"./clipart/standard/Standard02.png": 2696,
	"./clipart/standard/Standard03.png": 2641,
	"./clipart/standard/Standard04.png": 6526,
	"./clipart/standard/Standard05.png": 4215,
	"./clipart/standard/Standard06.png": 9388,
	"./clipart/standard/Standard07.png": 2277,
	"./clipart/standard/Standard08.png": 274,
	"./clipart/standard/Standard09.png": 5627,
	"./clipart/standard/Standard10.png": 7685,
	"./clipart/standard/Standard11.png": 8268,
	"./clipart/standard/Standard12.png": 8903,
	"./clipart/standard/Standard13.png": 5886,
	"./clipart/standard/Standard14.png": 2001,
	"./clipart/standard/Standard15.png": 3736,
	"./clipart/standard/Standard16.png": 8227,
	"./clipart/standard/Standard17.png": 3018,
	"./clipart/standard/Standard18.png": 7085,
	"./clipart/standard/Standard19.png": 5956,
	"./clipart/standard/Standard20.png": 9648,
	"./clipart/standard/Standard21.png": 4473,
	"./clipart/standard/Standard22.png": 3762,
	"./clipart/standard/Standard23.png": 1627,
	"./clipart/standard/Standard24.png": 9972,
	"./clipart/standard/Standard25.png": 6269,
	"./clipart/standard/Standard26.png": 4646,
	"./clipart/standard/Standard27.png": 4623,
	"./clipart/standard/Standard28.png": 2360,
	"./clipart/standard/Standard29.png": 6577,
	"./clipart/standard/Standard30.png": 7547,
	"./clipart/standard/Standard31.png": 7042,
	"./clipart/standard/Standard32.png": 9977,
	"./clipart/standard/Standard33.png": 3728,
	"./clipart/standard/Standard34.png": 2751,
	"./clipart/standard/Standard35.png": 7558,
	"./clipart/standard/Standard36.png": 8765,
	"./clipart/standard/Standard37.png": 7636,
	"./clipart/standard/Standard38.png": 3555,
	"./clipart/standard/Standard39.png": 7994,
	"./clipart/standard/Standard40.png": 950,
	"./clipart/standard/Standard41.png": 7887,
	"./clipart/standard/Standard42.png": 1028,
	"./clipart/standard/Standard43.png": 4925,
	"./clipart/standard/Standard44.png": 66,
	"./clipart/standard/Standard45.png": 4891,
	"./clipart/standard/Standard46.png": 6560,
	"./clipart/standard/Standard47.png": 4681,
	"./clipart/standard/Standard48.png": 5166,
	"./clipart/standard/Standard49.png": 7655,
	"./overlays/Black/BlackFrame01.png": 2132,
	"./overlays/Black/BlackFrame02.png": 4591,
	"./overlays/Black/BlackFrame03.png": 9494,
	"./overlays/Black/BlackFrame04.png": 8121,
	"./overlays/Black/BlackFrame05.png": 2368,
	"./overlays/Black/BlackFrame06.png": 7771,
	"./overlays/Black/BlackFrame07.png": 4114,
	"./overlays/Black/BlackFrame08.png": 4981,
	"./overlays/Golden/GoldFrame01.png": 1731,
	"./overlays/Golden/GoldFrame02.png": 4872,
	"./overlays/Golden/GoldFrame03.png": 4817,
	"./overlays/Golden/GoldFrame04.png": 8702,
	"./overlays/Golden/GoldFrame05.png": 39,
	"./overlays/Golden/GoldFrame06.png": 1564,
	"./overlays/Golden/GoldFrame07.png": 4453,
	"./overlays/Green/GreenFrame01.png": 4156,
	"./overlays/Green/GreenFrame02.png": 4791,
	"./overlays/Green/GreenFrame03.png": 5422,
	"./overlays/Green/GreenFrame04.png": 7889,
	"./overlays/Green/GreenFrame05.png": 3272,
	"./overlays/Green/GreenFrame06.png": 7763,
	"./overlays/Green/GreenFrame07.png": 8906,
	"./overlays/Green/GreenFrame08.png": 2973,
	"./overlays/pink/PinkFrame01.png": 5802,
	"./overlays/pink/PinkFrame02.png": 5969,
	"./overlays/pink/PinkFrame03.png": 1752,
	"./overlays/pink/PinkFrame04.png": 3271,
	"./overlays/pink/PinkFrame05.png": 4958,
	"./overlays/pink/PinkFrame06.png": 2309,
	"./overlays/pink/PinkFrame07.png": 3212,
	"./sketches/care/Care01.png": 3098,
	"./sketches/care/Care02.png": 4209,
	"./sketches/care/Care03.png": 3992,
	"./sketches/care/Care04.png": 3607,
	"./sketches/care/Care05.png": 1118,
	"./sketches/care/Care06.png": 5602,
	"./sketches/care/Care07.png": 956,
	"./sketches/care/Care08.png": 843,
	"./sketches/care/Care09.png": 6018,
	"./sketches/care/Care10.png": 248,
	"./sketches/care/Care11.png": 1377,
	"./sketches/care/Care12.png": 3946,
	"./sketches/care/Care13.png": 5859,
	"./sketches/food/food01.png": 3452,
	"./sketches/food/food02.png": 1559,
	"./sketches/food/food03.png": 5982,
	"./sketches/food/food04.png": 3697,
	"./sketches/food/food05.png": 2568,
	"./sketches/food/food06.png": 8323,
	"./sketches/food/food07.png": 3114,
	"./sketches/food/food08.png": 9709,
	"./sketches/food/food09.png": 3028,
	"./sketches/food/food10.png": 1802,
	"./sketches/food/food11.png": 1635,
	"./sketches/miscellaneous/miscellaneous01.png": 490,
	"./sketches/miscellaneous/miscellaneous02.png": 1601,
	"./sketches/miscellaneous/miscellaneous03.png": 1384,
	"./sketches/miscellaneous/miscellaneous04.png": 999,
	"./sketches/miscellaneous/miscellaneous05.png": 8510,
	"./sketches/miscellaneous/miscellaneous06.png": 4261,
	"./sketches/miscellaneous/miscellaneous07.png": 8348,
	"./sketches/miscellaneous/miscellaneous08.png": 8235,
	"./sketches/miscellaneous/miscellaneous09.png": 3410,
	"./sketches/miscellaneous/miscellaneous10.png": 8907,
	"./sketches/miscellaneous/miscellaneous11.png": 2417,
	"./sketches/miscellaneous/miscellaneous12.png": 1338,
	"./sketches/miscellaneous/miscellaneous13.png": 3251,
	"./sketches/miscellaneous/miscellaneous14.png": 5852,
	"./sketches/miscellaneous/miscellaneous15.png": 1765,
	"./sketches/miscellaneous/miscellaneous16.png": 3934,
	"./sketches/miscellaneous/miscellaneous17.png": 3431,
	"./sketches/miscellaneous/miscellaneous18.png": 7072,
	"./sketches/miscellaneous/miscellaneous19.png": 3321,
	"./sketches/miscellaneous/miscellaneous20.png": 9197,
	"./sketches/miscellaneous/miscellaneous21.png": 8068,
	"./sketches/miscellaneous/miscellaneous22.png": 6975,
	"./sketches/miscellaneous/miscellaneous23.png": 7958,
	"./sketches/miscellaneous/miscellaneous24.png": 1033,
	"./sketches/miscellaneous/miscellaneous25.png": 4128,
	"./sketches/miscellaneous/miscellaneous26.png": 3979,
	"./sketches/smilies/smilies01.png": 1698,
	"./sketches/smilies/smilies02.png": 2409,
	"./sketches/smilies/smilies03.png": 7584,
	"./sketches/smilies/smilies04.png": 8911,
	"./sketches/smilies/smilies05.png": 2582,
	"./sketches/sports/sports01.png": 2790,
	"./sketches/sports/sports02.png": 4413,
	"./sketches/sports/sports03.png": 8116,
	"./sketches/sports/sports04.png": 9771,
	"./sketches/sports/sports05.png": 1906,
	"./sketches/sports/sports06.png": 2617,
	"./sketches/sports/sports07.png": 7792,
	"./sketches/sports/sports08.png": 2023,
	"./sketches/sports/sports09.png": 3710,
	"./sketches/sports/sports10.png": 4100,
	"./sketches/weapons/weapons01.png": 9562,
	"./sketches/weapons/weapons02.png": 6993,
	"./sketches/weapons/weapons03.png": 9512,
	"./sketches/weapons/weapons04.png": 1655,
	"./sketches/wildlife/wildlife01.png": 8248,
	"./sketches/wildlife/wildlife02.png": 5107,
	"./sketches/wildlife/wildlife03.png": 7354,
	"./sketches/wildlife/wildlife04.png": 1125,
	"./sketches/wildlife/wildlife05.png": 5212,
	"./sketches/wildlife/wildlife06.png": 7863,
	"./sketches/wildlife/wildlife07.png": 5374,
	"./sketches/wildlife/wildlife08.png": 1241,
	"./sketches/wildlife/wildlife09.png": 6768,
	"./sketches/wildlife/wildlife10.png": 7270,
	"./sketches/wildlife/wildlife11.png": 3599,
	"./sketches/zodiac/zodiac01.png": 3856,
	"./sketches/zodiac/zodiac02.png": 3707,
	"./sketches/zodiac/zodiac03.png": 2578,
	"./sketches/zodiac/zodiac04.png": 8925,
	"./sketches/zodiac/zodiac05.png": 7796,
	"./sketches/zodiac/zodiac06.png": 6703,
	"./sketches/zodiac/zodiac07.png": 7686,
	"./sketches/zodiac/zodiac08.png": 3841,
	"./sketches/zodiac/zodiac09.png": 9224,
	"./sketches/zodiac/zodiac10.png": 5985,
	"./sketches/zodiac/zodiac11.png": 9703,
	"./sketches/zodiac/zodiac12.png": 1228,
	"./standard/Animals/Animals01.jpg": 9781,
	"./standard/Animals/Animals02.jpg": 2442,
	"./standard/Animals/Animals03.jpg": 1447,
	"./standard/Animals/Animals04.jpg": 7660,
	"./standard/Animals/Animals05.jpg": 1385,
	"./standard/Animals/Animals06.jpg": 8894,
	"./standard/Animals/Animals07.jpg": 5355,
	"./standard/Animals/Animals08.jpg": 448,
	"./standard/Animals/Animals09.jpg": 3901,
	"./standard/Animals/Animals10.jpg": 2084,
	"./standard/Animals/Animals11.jpg": 8538,
	"./standard/Animals/Animals12.jpg": 6389,
	"./standard/Animals/Animals13.jpg": 8776,
	"./standard/Animals/Animals14.jpg": 363,
	"./standard/Animals/Animals15.jpg": 9054,
	"./standard/Animals/Animals16.jpg": 5001,
	"./standard/Animals/Animals17.jpg": 3388,
	"./standard/Animals/Animals18.jpg": 6604,
	"./standard/Animals/Animals19.jpg": 7842,
	"./standard/Animals/Animals20.jpg": 1618,
	"./standard/Animals/Animals21.jpg": 7999,
	"./standard/CitiLights/CityLights01.jpg": 8575,
	"./standard/CitiLights/CityLights02.jpg": 1936,
	"./standard/CitiLights/CityLights03.jpg": 1149,
	"./standard/CitiLights/CityLights04.jpg": 630,
	"./standard/CitiLights/CityLights05.jpg": 5891,
	"./standard/CitiLights/CityLights06.jpg": 2196,
	"./standard/CitiLights/CityLights07.jpg": 241,
	"./standard/CitiLights/CityLights08.jpg": 2890,
	"./standard/CitiLights/CityLights09.jpg": 4055,
	"./standard/Flowers/Flowers01.jpg": 5305,
	"./standard/Flowers/Flowers02.jpg": 2814,
	"./standard/Flowers/Flowers03.jpg": 9275,
	"./standard/Flowers/Flowers04.jpg": 6440,
	"./standard/Flowers/Flowers05.jpg": 3701,
	"./standard/Flowers/Flowers06.jpg": 6362,
	"./standard/Flowers/Flowers07.jpg": 5367,
	"./standard/Miscellaneous/Miscellaneous01.jpg": 9557,
	"./standard/Miscellaneous/Miscellaneous02.jpg": 1706,
	"./standard/Miscellaneous/Miscellaneous03.jpg": 2871,
	"./standard/Miscellaneous/Miscellaneous04.jpg": 6556,
	"./standard/Miscellaneous/Miscellaneous05.jpg": 1817,
	"./standard/Miscellaneous/Miscellaneous06.jpg": 2222,
	"./standard/Miscellaneous/Miscellaneous07.jpg": 3531,
	"./standard/Miscellaneous/Miscellaneous08.jpg": 4400,
	"./standard/Miscellaneous/Miscellaneous09.jpg": 9965,
	"./standard/Miscellaneous/Miscellaneous10.jpg": 5799,
	"./standard/Miscellaneous/Miscellaneous11.jpg": 9962,
	"./standard/Miscellaneous/Miscellaneous12.jpg": 9861,
	"./standard/Miscellaneous/Miscellaneous13.jpg": 1992,
	"./standard/Scenery/Scenery01.jpg": 4685,
	"./standard/Scenery/Scenery02.jpg": 8754,
	"./standard/Scenery/Scenery03.jpg": 463,
	"./standard/Scenery/Scenery04.jpg": 9028,
	"./standard/Scenery/Scenery05.jpg": 3361,
	"./standard/Scenery/Scenery06.jpg": 5606,
	"./standard/Scenery/Scenery07.jpg": 8739,
	"./standard/Scenery/Scenery08.jpg": 4280,
	"./standard/Scenery/Scenery09.jpg": 2149,
	"./standard/Scenery/Scenery10.jpg": 8972,
	"./standard/Scenery/Scenery11.jpg": 8658,
	"./standard/Scenery/Scenery12.jpg": 8557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6797;